"use client";

import { MouseEvent, TouchEvent } from "react";

// onMouseDown
const rippleEffect = (
  e:
    | MouseEvent<HTMLButtonElement | HTMLAnchorElement>
    | TouchEvent<HTMLButtonElement | HTMLAnchorElement>,
) => {
  const div = document.createElement("div");
  div.className = "ripple";
  e.currentTarget.appendChild(div);
  const radius = Math.ceil(
    Math.sqrt(
      e.currentTarget.clientWidth ** 2 + e.currentTarget.clientWidth ** 2,
    ),
  );
  const [left, top] = [
    ("clientX" in e ? e.clientX : e.targetTouches[0].clientX) -
      e.currentTarget.getBoundingClientRect().left,
    ("clientY" in e ? e.clientY : e.targetTouches[0].clientY) -
      e.currentTarget.getBoundingClientRect().top,
  ];
  div?.setAttribute(
    "style",
    `inline-size: ${radius * 2}px; block-size: ${
      radius * 2
    }px; transform: scale(1); opacity: 0; left: calc(${left}px - ${radius}px); top: calc(${top}px - ${radius}px);`,
  );
  setTimeout(() => div.remove(), 900);
};

export default rippleEffect;
